import React from "react";
import { motion } from "framer-motion";
import DecryptedText from "./DecryptedText";
import { FaCalendarAlt, FaDollarSign } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import { HiTrophy } from "react-icons/hi2";

const HeroSafari = () => {
  const circuitDelay = 0;

  return (
    <div className="relative min-h-screen pt-16 flex items-center justify-center overflow-hidden bg-white dark:bg-gray-900 transition-colors duration-300">
      {/* Animated Gears */}
      <div className="absolute inset-0 hidden xl:block z-5">
        <style jsx>{`
          .gear-small {
            animation: counter-rotation 2.5s infinite linear;
            transform-origin: 100px 225px;
          }
          .gear-medium {
            animation: rotation 3.75s infinite linear;
            transform-origin: 255px 379px;
          }
          .gear-large {
            animation: counter-rotation 5s infinite linear;
            transform-origin: 461px 174px;
          }
          @keyframes rotation {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(359deg);
            }
          }
          @keyframes counter-rotation {
            from {
              transform: rotate(359deg);
            }
            to {
              transform: rotate(0deg);
            }
          }
        `}</style>

        {/* Right corner gears */}
        {/*}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.1 }}
          transition={{ duration: 1.5, delay: 0.5 }}
          className="absolute top-20 left-20 w-48 h-48 dark:opacity-20"
        >
          <svg
            className="w-full h-full text-gray-800 dark:text-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 645 526"
            fill="currentColor"
          >
            <g className="gear-small">
              <path d="M200 236v-21l-29-4c-2-10-6-18-11-26l18-23 -15-15 -23 18c-8-5-17-9-26-11l-4-29H90l-4 29c-10 2-18 6-26 11l-23-18 -15 15 18 23c-5 8-9 17-11 26L0 215v21l29 4c2 10 6 18 11 26l-18 23 15 15 23-18c8 5 17 9 26 11l4 29h21l4-29c10-2 18-6 26-11l23 18 15-15 -18-23c5-8 9-17 11-26L200 236zM100 262c-20 0-37-17-37-37s17-37 37-37c20 0 37 17 37 37S121 262 100 262z" />
            </g>
            <g className="gear-medium">
              <path d="M392 390v-21l-28-4c-1-10-4-19-7-28l23-17 -11-18L342 313c-6-8-13-14-20-20l11-26 -18-11 -17 23c-9-4-18-6-28-7l-4-28h-21l-4 28c-10 1-19 4-28 7l-17-23 -18 11 11 26c-8 6-14 13-20 20l-26-11 -11 18 23 17c-4 9-6 18-7 28l-28 4v21l28 4c1 10 4 19 7 28l-23 17 11 18 26-11c6 8 13 14 20 20l-11 26 18 11 17-23c9 4 18 6 28 7l4 28h21l4-28c10-1 19-4 28-7l17 23 18-11 -11-26c8-6 14-13 20-20l26 11 11-18 -23-17c4-9 6-18 7-28L392 390zM255 453c-41 0-74-33-74-74 0-41 33-74 74-74 41 0 74 33 74 74C328 420 295 453 255 453z" />
            </g>
            <g className="gear-large">
              <path d="M635 184v-21l-29-4c-1-10-3-19-6-28l25-14 -8-19 -28 7c-5-8-10-16-16-24L592 58l-15-15 -23 17c-7-6-15-11-24-16l7-28 -19-8 -14 25c-9-3-18-5-28-6L472 0h-21l-4 29c-10 1-19 3-28 6L405 9l-19 8 7 28c-8 5-16 10-24 16l-23-17L331 58l17 23c-6 7-11 15-16 24l-28-7 -8 19 25 14c-3 9-5 18-6 28l-29 4v21l29 4c1 10 3 19 6 28l-25 14 8 19 28-7c5 8 10 16 16 24l-17 23 15 15 23-17c7 6 15 11 24 16l-7 28 19 8 14-25c9 3 18 5 28 6l4 29h21l4-29c10-1 19-3 28-6l14 25 19-8 -7-28c8-5 16-10 24-16l23 17 15-15 -17-23c6-7 11-15 16-24l28 7 8-19 -25-14c3-9 5-18 6-28L635 184zM461 284c-61 0-110-49-110-110S401 64 461 64s110 49 110 110S522 284 461 284z" />
            </g>
          </svg>
        </motion.div>
        */}

        {/* Left corner gears */}
        {/*
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.1 }}
          transition={{ duration: 1.5, delay: 0.8 }}
          className="absolute bottom-20 right-20 w-48 h-48 dark:opacity-20"
        >
          <svg
            className="w-full h-full text-gray-800 dark:text-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 645 526"
            fill="currentColor"
          >
            <g className="gear-small">
              <path d="M200 236v-21l-29-4c-2-10-6-18-11-26l18-23 -15-15 -23 18c-8-5-17-9-26-11l-4-29H90l-4 29c-10 2-18 6-26 11l-23-18 -15 15 18 23c-5 8-9 17-11 26L0 215v21l29 4c2 10 6 18 11 26l-18 23 15 15 23-18c8 5 17 9 26 11l4 29h21l4-29c10-2 18-6 26-11l23 18 15-15 -18-23c5-8 9-17 11-26L200 236zM100 262c-20 0-37-17-37-37s17-37 37-37c20 0 37 17 37 37S121 262 100 262z" />
            </g>
            <g className="gear-medium">
              <path d="M392 390v-21l-28-4c-1-10-4-19-7-28l23-17 -11-18L342 313c-6-8-13-14-20-20l11-26 -18-11 -17 23c-9-4-18-6-28-7l-4-28h-21l-4 28c-10 1-19 4-28 7l-17-23 -18 11 11 26c-8 6-14 13-20 20l-26-11 -11 18 23 17c-4 9-6 18-7 28l-28 4v21l28 4c1 10 4 19 7 28l-23 17 11 18 26-11c6 8 13 14 20 20l-11 26 18 11 17-23c9 4 18 6 28 7l4 28h21l4-28c10-1 19-4 28-7l17 23 18-11 -11-26c8-6 14-13 20-20l26 11 11-18 -23-17c4-9 6-18 7-28L392 390zM255 453c-41 0-74-33-74-74 0-41 33-74 74-74 41 0 74 33 74 74C328 420 295 453 255 453z" />
            </g>
            <g className="gear-large">
              <path d="M635 184v-21l-29-4c-1-10-3-19-6-28l25-14 -8-19 -28 7c-5-8-10-16-16-24L592 58l-15-15 -23 17c-7-6-15-11-24-16l7-28 -19-8 -14 25c-9-3-18-5-28-6L472 0h-21l-4 29c-10 1-19 3-28 6L405 9l-19 8 7 28c-8 5-16 10-24 16l-23-17L331 58l17 23c-6 7-11 15-16 24l-28-7 -8 19 25 14c-3 9-5 18-6 28l-29 4v21l29 4c1 10 3 19 6 28l-25 14 8 19 28-7c5 8 10 16 16 24l-17 23 15 15 23-17c7 6 15 11 24 16l-7 28 19 8 14-25c9 3 18 5 28 6l4 29h21l4-29c10-1 19-3 28-6l14 25 19-8 -7-28c8-5 16-10 24-16l23 17 15-15 -17-23c6-7 11-15 16-24l28 7 8-19 -25-14c3-9 5-18 6-28L635 184zM461 284c-61 0-110-49-110-110S401 64 461 64s110 49 110 110S522 284 461 284z" />
            </g>
          </svg>
        </motion.div>
        */}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-gray-900 dark:text-white px-4 sm:px-6 lg:px-8 3xl:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="text-lg md:text-xl font-medium mb-4 text-gray-600 dark:text-gray-400"
          >
            AI Fund and DeepLearning.AI present:
          </motion.p>

          <div className="mb-6 flex justify-center">
            <img
              src="/buildathon_logo.png"
              alt="Buildathon"
              className="h-16 md:h-24 3xl:h-32 w-auto"
            />
          </div>

          <p className="text-xl md:text-2xl 3xl:text-3xl font-light mb-8 max-w-3xl 3xl:max-w-5xl mx-auto text-gray-700 dark:text-gray-300">
            <DecryptedText
              text="From Zero to Product in a Day"
              animateOn="view"
              revealDirection="center"
              speed={80}
              maxIterations={15}
              className="font-light"
              delay={100}
            />
          </p>

          {/* Event Details */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 3xl:gap-8 mb-12 max-w-4xl 3xl:max-w-7xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative bg-gray-50 dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700 transition-colors duration-300"
            >
              {/* Circuit Background positioned relative to location box - Safari optimized */}
              <div className="absolute right-[98%] -mr-12 top-1/2 -translate-y-1/2 w-[35rem] 3xl:w-[55rem] 4xl:w-[70rem] 5xl:w-[90rem] h-[45rem] 3xl:h-[65rem] 4xl:h-[80rem] 5xl:h-[100rem] opacity-30 dark:opacity-20 pointer-events-none -z-10 overflow-hidden">
                <div className="w-full h-full flex items-center justify-center">
                  <motion.img
                    src="/Circuit Primary (2)-cropped.svg"
                    alt="Circuit Background"
                    initial={{ clipPath: "inset(0 100% 0 0)" }}
                    animate={{ clipPath: "inset(0 0% 0 0)" }}
                    transition={{
                      duration: 2,
                      delay: circuitDelay,
                      ease: "easeOut",
                    }}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <div className="text-3xl font-bold mb-2 text-red-500 dark:text-red-400 flex justify-center">
                <MdLocationOn />
              </div>
              <h3 className="font-semibold mb-2 text-gray-900 dark:text-white">
                Location
              </h3>
              <p className="text-md text-gray-600 dark:text-gray-300">
                Menlo Park, CA
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="bg-gray-50 dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700 transition-colors duration-300"
            >
              <div className="text-3xl font-bold mb-2 text-blue-500 dark:text-blue-400 flex justify-center">
                <FaCalendarAlt />
              </div>
              <h3 className="font-semibold mb-2 text-gray-900 dark:text-white">
                Date
              </h3>
              <p className="text-md text-gray-600 dark:text-gray-300">
                August 16, 2025
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="relative bg-gray-50 dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700 transition-colors duration-300"
            >
              {/* Circuit Background positioned relative to prizes box - Safari optimized */}
              <div className="absolute left-[98%] -ml-12 top-1/2 -translate-y-1/2 w-[35rem] 3xl:w-[55rem] 4xl:w-[70rem] 5xl:w-[90rem] h-[45rem] 3xl:h-[65rem] 4xl:h-[80rem] 5xl:h-[100rem] opacity-30 dark:opacity-20 pointer-events-none -z-10 overflow-hidden">
                <div className="w-full h-full flex items-center justify-center">
                  <motion.img
                    src="/Circuit Primary (2)-cropped.svg"
                    alt="Circuit Background"
                    initial={{ clipPath: "inset(0 100% 0 0)" }}
                    animate={{ clipPath: "inset(0 0% 0 0)" }}
                    transition={{
                      duration: 2,
                      delay: circuitDelay,
                      ease: "easeOut",
                    }}
                    className="w-full h-full object-contain transform scale-x-[-1]"
                  />
                </div>
              </div>
              <div className="text-3xl font-bold mb-2 text-yellow-500 dark:text-yellow-400 flex justify-center">
                <HiTrophy />
              </div>
              <h3 className="font-semibold mb-2 text-gray-900 dark:text-white">
                Prizes
              </h3>
              <p className="text-md text-gray-600 dark:text-gray-300">
                $3,000+ in prizes
              </p>
            </motion.div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.a
              href="https://www.youtube.com/live/Brz7GaUPEDw"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-aifund text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-200 inline-block text-center"
            >
              Livestream
            </motion.a>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          className="mt-8 mb-8 bg-gradient-to-r from-aifund/10 to-aifund-light/10 rounded-lg p-4 border border-aifund/20 backdrop-blur-sm"
        >
          <p className="text-base font-medium text-aifund dark:text-aifund-light text-center">
            Each participant will receive <strong>$100</strong>
            <br className="sm:hidden" /> in Claude credits and one month of free
            Replit Core.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSafari;
